import { render, staticRenderFns } from "./ProjectRequestForm.vue?vue&type=template&id=0422b71c&"
import script from "./ProjectRequestForm.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRequestForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports